import React, { createContext, useContext, useState, useEffect } from 'react'
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [openLogin, setOpenLogin] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [wallet, setWallet] = useState();


  return (
    <AuthContext.Provider
      value={{
        openLogin,
        setOpenLogin,
        isAuth,
        setIsAuth,
        wallet,
        setWallet,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);
